module.exports = __webpack_public_path__ + "img/gb-whatsapp-icon.6b36e867.svg";